import React, { Component } from "react";
import Button from "../../Button/Button";

class BasicInfoBlock extends Component {
	render() {
		let noInfo = "N/A";
		return (
			<div className="account-info-block">
				<h2>Basic Information</h2>
				<div className="account-info-col-container">
					<div className="account-info-l">
						<p className="account-info-label">Name</p>
						<p className="account-info-label">Email</p>
						<p className="account-info-label">Company</p>
					</div>
					<div className="account-info-r">
						<p className="account-info-text">
							{this.props.info["firstName"] && this.props.info["lastName"]
								? `${this.props.info["firstName"]} ${this.props.info[
										"lastName"
									]}`
								: noInfo}
						</p>
						<p className="account-info-text">
							{this.props.info["email"] ? this.props.info["email"] : noInfo}
						</p>
						<p className="account-info-text">
							{this.props.info["company"] ? this.props.info["company"] : noInfo}
						</p>
					</div>
				</div>
				<Button
					label="Edit Info"
					onClick={() =>
						this.props.changeLocation(
							"/dashboard/account/edit-basic-information"
						)}
				/>
			</div>
		);
	}
}

export default BasicInfoBlock;


// WEBPACK FOOTER //
// ./src/components/Account/BasicInfoBlock/BasicInfoBlock.js